import { render, staticRenderFns } from "./modalProductImageUpload.vue?vue&type=template&id=68cbc72c&scoped=true&"
import script from "./modalProductImageUpload.vue?vue&type=script&lang=js&"
export * from "./modalProductImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./modalProductImageUpload.vue?vue&type=style&index=0&id=68cbc72c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cbc72c",
  null
  
)

export default component.exports